import { useMatch, useParams } from 'react-router';
import { E_APP_ROUTES } from '@router/enums';
import { useUIStore } from '@store/UIStore';
import { Modal, Tooltip, Typography } from 'yoc-ui-library';

import { E_REPORT_ACTIONS_LAYOUT } from '@common/configs';
import { classesBuilder } from '@common/helpers';
import { useIsMobile } from '@common/hooks';
import Icon from '@components/Icon';
import ReportActions from '@components/ReportActions';
import ReportContent from '@components/ReportContent';
import Sidebar from '@components/Sidebar';

import { useActiveSection, useReportActions, useReportPageData, useTextEllipsis } from './hooks';

import style from './styles.module.scss';

const ReportPage = () => {
  // TODO: Added for dev/text purposes will remove this.
  const longText = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
    Etiam vitae urna at lorem dapibus ullamcorper. 
    Pellentesque luctus metus at risus sagittis, quis facilisis turpis viverra. 
    Vivamus posuere, dolor sed laoreet cursus, justo augue pretium enimnec hendrerit nulla purus in purus. 
    Vestibulum viverra lacinia felis, eu tristique ante. 
    Proin dignissim pharetra dui nec dictum. 
    Sed posuere, purus ac dictum cursus, ante sapien sagittis ligula, id malesuada sem elit a orci. 
    Etiam vestibulum nibh nec mi faucibus, vitae ultrices nulla dictum. 
    Pellentesque nec velit ac velit gravida egestas. 
    Duis eget turpis feugiat, blandit erat eu, scelerisque ipsum. 
    Aenean sed quam quam. Praesent egestas erat in augue dictum, ac eleifend urna elementum. 
    In posuere molestie pretium. Pellentesque gravida pretium ornare.`;
  const { id } = useParams<{ id: string }>();
  const isReportPage = !!useMatch(E_APP_ROUTES.REPORT);
  const { report, sections } = useReportPageData(id);
  const { shouldEllipsis, displayText } = useTextEllipsis(longText);
  const { activeId, slideRefs } = useActiveSection(sections);
  const isMobile = useIsMobile();
  const { showReportActions, openReportActions, closeReportActions } = useReportActions();
  const showMobileSidebar = useUIStore((state) => {
    return state.showMobileSidebar;
  });

  return (
    <div className={style.wrapper}>
      <div className={style['campaign-wrapper']}>
        {isReportPage && report && (
          <>
            <div className={style['campaign-name-key']}>
              <mark>{report.id}:</mark>
              <Typography.Text className={style['campaign-name']}>
                <Tooltip title={shouldEllipsis ? longText : undefined}>{displayText}</Tooltip>
              </Typography.Text>
            </div>
            {!isMobile && (
              <Tooltip
                title="Report Actions"
                placement="left"
              >
                <Icon
                  name="settings"
                  onClick={openReportActions}
                />
              </Tooltip>
            )}
            {showReportActions && (
              <Modal
                className={style.actions}
                open={showReportActions}
                onCancel={closeReportActions}
                closable={false}
                footer={null}
              >
                <ReportActions layout={E_REPORT_ACTIONS_LAYOUT.GRID} />
              </Modal>
            )}
          </>
        )}
      </div>
      <div
        className={classesBuilder(style.holder, {
          [style.hidden]: !showMobileSidebar && isMobile,
          [style.visible]: showMobileSidebar && isMobile,
        })}
      >
        <Sidebar
          sectionData={sections}
          activeId={activeId}
          slideRefs={slideRefs}
        />

        <ReportContent
          sectionData={sections}
          slideRefs={slideRefs}
        />
      </div>
    </div>
  );
};

export default ReportPage;
